/**
 * Normalización de una contraseña NUEVA (TAN-11554): lo que se pega desde un correo o un gestor
 * de contraseñas suele arrastrar espacios o tabuladores en los extremos. Solo para los campos
 * donde el usuario crea una contraseña (alta, recuperar por enlace, cambio obligatorio y perfil),
 * y siempre también sobre el valor del propio campo (`onBlur`): lo que ve el usuario, lo que
 * guarda el gestor de contraseñas y lo que recibe el API tienen que coincidir, o el siguiente
 * login fallaría. Nunca en el login ni en «contraseña actual»: puede haber contraseñas guardadas
 * con espacios en los extremos y el API las compara tal cual.
 */

import type { UseFormMethods } from 'react-hook-form';

export const PASSWORD_MIN_LENGTH = 3;

type NewPasswordFormMethods = Pick<UseFormMethods, 'getValues' | 'setValue'>;

/** `undefined` y `null` cuentan como vacío. */
export function normalizeNewPassword(value?: string | null): string {
  return (value ?? '').trim();
}

/**
 * Validador para `register({ validate })` de react-hook-form 6: `required` y `minLength` miran el
 * valor crudo del input, así que «   » o « ab » los pasan; este mide el valor normalizado.
 */
export function hasNewPasswordMinLength(value?: string | null): boolean {
  return normalizeNewPassword(value).length >= PASSWORD_MIN_LENGTH;
}

/**
 * Deja el propio campo con el valor normalizado (react-hook-form 6). Se llama al salir del campo
 * y antes de validar en el submit, para que el error de longitud hable del valor que el usuario ve.
 */
export function normalizeNewPasswordField({ getValues, setValue }: NewPasswordFormMethods, name: string): void {
  setValue(name, normalizeNewPassword(getValues(name)));
}
